import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";

import introJs from "intro.js";
import "intro.js/introjs.css";

import api from "../../services/api";
import { isTotvs } from "../../services/globalFunctions";

//Components
import HeaderV2 from "../../components/headerV2";
import Recipe from "../../components/nova-home/recipe";
import Updates from "../../components/nova-home/updates";
import ButtonV2 from "../../components/button/button_v2";
import Calendary from "../../components/nova-home/calendary";
import CircleData from "../../components/nova-home/circle-data";
import TreatedArea from "../../components/nova-home/treated-area";
import LastRecipes from "../../components/last-recipes";
import ModalGenericV2 from "../../components/modal/modalGenericV2";
import Notifications from "../../components/nova-home/notifications";
import FunctionBlockedOverlay from "../../components/functionBlocked";
import CardSolicitacoes from "../../components/totvs/cardSolicitacao";
import CropManagement from "../../components/nova-home/crop-management";
import CalendaryEvent from "../../components/nova-home/calendary-event";
import LastRecipesHome from "../../components/nova-home/last-recipes-home";
import CompendioSearch from "../../components/nova-home/compendio-agricola";
import CardNotification from "../../components/nova-home/card-notification";
import ModalBlock from "../../components/modal/modalFuncaoBloqueadaImpressaoFe";
// import NewCardNotification from '../../components/nova-home/card-notification';
import ModalFuncaoBloqueadaImpressaoFe from "../../components/modal/modalFuncaoBloqueadaImpressaoFe";
import AlertExportRevenue from "../../components/AlertExportRevenue";

import iconSearch from "../../assets/img-undraw-search.svg";
import iconTableBlue from "../../assets/icons/totvs/icon-table-blue.png";

import * as S from "./styles";
import { theme } from "../../styles/theme";
import { BodyG, H5, TaglineMSpan } from "../../styles/stylesTypography";

export const compendioG = "@compendioG";

const USER = JSON.parse(localStorage.getItem("@userinfo"));

const isFunctionBlocked = (user) => {
  const planId = user?.contrato?.agro_plan_config?.agro_plan_id;
  const diasRestante = Number(user?.contrato?.dias_restante ?? 0);
  return (
    planId === 7 ||
    planId === 6 ||
    planId === 4 ||
    (planId === 1 && diasRestante <= 0)
  );
};

const NovaHome = ({ ...props }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [allRecipes, setAllRecipes] = useState([]);
  const [openModalTrue, setOpenModalTrue] = useState(false);

  const treatedAreaBlockedRef = useRef(null);
  const cropManagementBlockedRef = useRef(null);
  const calendaryBlockedRef = useRef(null);
  const [isBlocked, setIsBlocked] = useState(false);

  const alvoRef = useRef(null);
  const cropBlocked = useRef(null);
  const treatedAreaRef = useRef(null);
  const [prescriptions, setPrescriptions] = useState([]); // itens de solicitações TOTVS (limitados a 3)

  const [hasVerifyPedidos, setHasVerifyPedidos] = useState(false);
  const [dataVerifyPedidos, setDataVerifyPedidos] = useState("");

  if (localStorage.getItem("lastAttemptedPath")) {
    const lastPath = localStorage.getItem("lastAttemptedPath");

    if (lastPath.includes("utm_source")) {
      let url = new URL(lastPath);

      let queryString = url.search;

      localStorage.setItem("utm_compra", queryString.substring(1));
    }

    localStorage.removeItem("lastAttemptedPath");

    window.location.href = lastPath;
  }

  const getAllRecipes = async () => {
    try {
      const response = await api.get("/home/receitas-emitidas");
      setAllRecipes(response.data.data);
    } catch (error) {}
  };

  // Busca apenas 3 solicitações para o CardSolicitacoes
  const getSolicitacoesPreview = async () => {
    try {
      const payload = {
        pedido: "",
        agronomos: [],
        status: [1],
        data_solicitacao: "",
        defensivos: [],
        produtores: [],
        culturas: []
      };
      const response = await api.post(`/rascunhos?limit=3&offset=0`, payload);
      const data = response?.data;
      setPrescriptions(data?.data?.prescriptions || []);
    } catch (error) {
      console.error("Erro ao buscar solicitações (preview)", error);
    }
  };

  useEffect(() => {
    getAllRecipes();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Carrega as solicitações (apenas 3 itens) na Home
  useEffect(() => {
    getSolicitacoesPreview();
  }, []);

  useEffect(() => {
    localStorage.setItem("@exit", "false");
    const startTour = localStorage.getItem("startTour");

    const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isIos) {
      // Não irá rodar onBoarding no IOS Mobile por enquanto.
      return;
    }

    if (startTour === "reload-needed") {
      localStorage.setItem("startTour", "true");
      window.location.reload();
    } else if (startTour === "true") {
      const intro = introJs();
      setTimeout(() => {
        window.scrollTo({
          top: window.scrollY - 500,
          behavior: "smooth",
        });

        intro.setOptions({
          steps: [
            {
              element: ".calendary",
              intro: `<div>
                          <h6>Previsão do tempo por Produtor</h6>
                          <p>Veja a previsão do tempo dos seus clientes rapidamente e melhore sua tomada de decisões.</p>
                      </div>`,
              tooltipClass: "custom-tooltip-calendary",
              position: "top",
            },
            {
              element: ".circleData",
              intro: `<div>
                          <h6>Saldo de Receitas e ART ou TRT</h6>
                          <p>Saiba seu saldo em tempo real e se organize melhor. Você também receberá por e-mail e WhatsApp.</p>
                      </div>`,
              tooltipClass: "custom-tooltip-circleData",
              position: "top",
            },
            {
              element: ".cropManagement",
              intro: `<div>
                          <h6>Acompanhe o manejo do dia</h6>
                          <p>Veja as tarefas recomendadas para cada talhão dos seus clientes e use os dados a seu favor.</p>
                      </div>`,
              tooltipClass: "custom-tooltip-cropManagement",
              position: "top",
            },
            {
              element: ".treatedArea",
              intro: `<div>
                          <h6>Relatórios inteligentes</h6>
                          <p>Receba relatórios com insights personalizados para aumentar a produtividade de cada talhão.</p>
                      </div>`,
              tooltipClass: "custom-tooltip-treatedArea",
              position: "top",
            },
          ],
          showStepNumbers: true,
          showBullets: false,
          scrollToElement: false,
          exitOnOverlayClick: false,
          prevLabel: "Anterior",
          nextLabel: "Próximo",
          doneLabel: "Começar",
        });

        intro.start();
        intro.goToStep(1);
      }, 500);

      intro.onchange(() => {
        const prevButton = document.querySelector(".introjs-prevbutton");
        if (intro._currentStep === 0) {
          if (prevButton) {
            prevButton.classList.add("introjs-hidden");
          }
        } else {
          if (prevButton) {
            prevButton.classList.remove("introjs-hidden");
          }
        }
      });

      intro.oncomplete(() => {
        localStorage.setItem("startTour", "completed");
        window.location.reload();
      });

      intro.onexit(() => {
        localStorage.setItem("startTour", "completed");
        window.location.reload();
      });
    }
  }, []);

  const checkCrea = async () => {
      try {
          await api.get(`/valida-crea`);
        } catch (error) {
          if (error.response.status === 422 && error.response.data.agronomo_id) {
            localStorage.setItem("@TOTVS_crea", "true");
            window.location.href = `/agronomos/edit/${error.response.data.agronomo_id}`;
          }
      }
  }

  useEffect(() => {
      const isBlocked = isFunctionBlocked(USER);
      setIsBlocked(isBlocked);
      checkCrea();
  }, []);

  const LayoutMobile = () => {
    if (width <= 1320) {
      return (
        <S.ContainerSections>
          <AlertExportRevenue />

          {isTotvs() ? (
            prescriptions.length > 0 && (
              <>
                <CardSolicitacoes items={prescriptions} maxWidth="1038px" onDataChanged={getSolicitacoesPreview}/>
              
                <a href="/solicitacoes-receitas" style={{gap: 8, display: 'flex', alignItems: 'center'}}>
                  <img src={iconTableBlue} alt="Ver todas as solicitações" style={{width: '16px', height: '16px'}}/>

                    <TaglineMSpan color={theme.colors.blue.Azul_link}>
                      Ver todas as solicitações
                  </TaglineMSpan>
                </a>
              </>
              )
          ):(
            <>
              {/* <CardNotification /> */}

              {allRecipes.length === 0 ? <Recipe /> : <LastRecipesHome />}
            </>
          )}


          <S.SectionOne>
            <div ref={calendaryBlockedRef} style={{ width: "100%" }}>
              <Calendary />
            </div>

            {isBlocked && (
              <FunctionBlockedOverlay
                visible
                mode="cover-parent"
                attachTo={calendaryBlockedRef}
                ctaType="activate"
                onActivate={() => setOpenModalTrue(true)}
              />
            )}

            <CompendioSearch />
          </S.SectionOne>

          <S.SectionTwo>
            <Notifications />

            <CircleData />
          </S.SectionTwo>
          
          <div ref={treatedAreaBlockedRef} style={{ width: "100%" }}>
            <TreatedArea overlayMode="none" />
          </div>

          {isBlocked && (
            <FunctionBlockedOverlay
              visible
              mode="cover-parent"
              attachTo={treatedAreaBlockedRef}
              ctaType="activate"
              onActivate={() => setOpenModalTrue(true)}
            />
          )}

          <S.SectionThree>
            <div ref={cropManagementBlockedRef} style={{ width: "100%" }}>
              <CropManagement overlayMode="none" />
            </div>

            {isBlocked && (
              <FunctionBlockedOverlay
                visible
                mode="cover-parent"
                attachTo={cropManagementBlockedRef}
                ctaType="activate"
                onActivate={() => setOpenModalTrue(true)}
              />
            )}

            <CalendaryEvent />
          </S.SectionThree>

          <Updates />
        </S.ContainerSections>
      );
    } else {
      return (
        <S.ContainerSections>
          <AlertExportRevenue />
          
          {isTotvs() ? (
              prescriptions.length > 0 && (
                <>
                  <CardSolicitacoes items={prescriptions} maxWidth="1038px" width="100%" onDataChanged={getSolicitacoesPreview} />

                  <a href="/solicitacoes-receitas" style={{gap: 8, display: 'flex', alignItems: 'center'}}>
                    <img src={iconTableBlue} alt="Ver todas as solicitações" style={{width: '16px', height: '16px'}}/>

                    <TaglineMSpan color={theme.colors.blue.Azul_link}>
                        Ver todas as solicitações
                    </TaglineMSpan>
                  </a>
                </>
              )
            ):(
              <>
                {/* <CardNotification /> */}

                {allRecipes.length === 0 ? <Recipe /> : <LastRecipesHome />}
              </>
            )}

          <S.SectionOne>
            <div ref={calendaryBlockedRef} style={{ width: "100%" }}>
              <Calendary />
            </div>

            {isBlocked && (
              <FunctionBlockedOverlay
                visible
                mode="cover-parent"
                attachTo={calendaryBlockedRef}
                ctaType="activate"
                onActivate={() => setOpenModalTrue(true)}
              />
            )}

            <CompendioSearch />

            <Notifications />
          </S.SectionOne>

          <S.SectionTwo>
            <CircleData />

            <div ref={treatedAreaBlockedRef} style={{ width: "100%" }}>
              <TreatedArea overlayMode="none" />
            </div>

            {isBlocked && (
                <FunctionBlockedOverlay
                  visible
                  mode="cover-parent"
                  attachTo={treatedAreaBlockedRef}
                  ctaType="activate"
                  onActivate={() => setOpenModalTrue(true)}
                />
              )}
          </S.SectionTwo>

          <S.SectionThree>
            <div ref={cropManagementBlockedRef} style={{ width: "100%" }}>
              <CropManagement overlayMode="none" />
            </div>

            {isBlocked && (
              <FunctionBlockedOverlay
                visible
                mode="cover-parent"
                attachTo={cropManagementBlockedRef}
                ctaType="activate"
                onActivate={() => setOpenModalTrue(true)}
              />
            )}

            <CalendaryEvent />

            <Updates />
          </S.SectionThree>
        </S.ContainerSections>
      );
    }
  };

  const getVerifyPedidos= async () => {
    if (!isTotvs()){
      return;
    }
    try {
      const response = await api.get("/valida-pedidos");

      if (response.status === 200) {
        setHasVerifyPedidos(true);
        setDataVerifyPedidos(response.data.message);
      } else {
        setHasVerifyPedidos(false);
      }
    } catch (error) {
      setHasVerifyPedidos(false);
    }
  };

  useEffect(() => {
    getVerifyPedidos();
  }, []);

  return (
    <>
      <S.GlobalStyles />

      <S.Container>
        <S.Wrapper>
          <S.HeaderWrapper>
            <HeaderV2 />
          </S.HeaderWrapper>

          {LayoutMobile()}
        </S.Wrapper>

        {openModalTrue && <ModalFuncaoBloqueadaImpressaoFe show={openModalTrue} onHide={() => setOpenModalTrue(false)} />}

        {hasVerifyPedidos && (
          <ModalGenericV2 
          show={hasVerifyPedidos} 
          onHide={() => setHasVerifyPedidos(false)}
          marginBottom="0"
          >
            <S.ContainerRTNotification>
              <img src={iconSearch} alt="Buscar" style={{width: '200px', height: 'auto'}}/>
             
             <H5 color={theme.colors.gray.Cinza_2}>
               Solicitações encontradas
             </H5>

             <BodyG>
               {dataVerifyPedidos}
             </BodyG>

              <ButtonV2
                width='200px'
                height='40px'
                value="Ver minhas solicitações"
                outline={false}
                disabled={false}
                onClick={() => window.location.href = "/solicitacoes-receitas"}
                loading={false}
              />
            </S.ContainerRTNotification>
          </ModalGenericV2>
        )}
      </S.Container>
    </>
  );
};

export default withRouter(NovaHome);
